exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tab-service-page {\n  position: relative;\n  text-align: left; }\n  .tab-service-page .tab-service-header {\n    margin-bottom: 10px; }\n  .tab-service-page .tab-service-main .table-header-main {\n    margin-bottom: 10px; }\n\n.add-packages-main {\n  padding: 20px; }\n", ""]);

// exports
